import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { ProjectService } from '../services/project/project.service';
import { AuthService } from '../services/auth/auth.service';

export const projectIdGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);

  const projectId = route.paramMap.get('projectId');
  if (projectId) {
    const projectService = inject(ProjectService);
    projectService.setProjectId(projectId);
    inject(AuthService).refreshRoleForProject(projectId);
  } else {
    router.navigate(['/projects/new']);
    return false;
  }

  return true;
};
